import React from "react";
import { SectionCta } from "../SectionCta";
import { AUTHOR_IMAGE } from "../../data/offer";
import { authorQuestions } from "../../data/framework";
export function AuthorSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-72" data-mp="3qyh03x1dlr76">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:items-start lg:gap-14" data-id="element-73" data-mp="3r1cw3ftny5sz">
        <div className="lg:sticky lg:top-8" data-id="element-74" data-mp="3vzy0lrfy7bn8">
          <div className="overflow-hidden rounded-3xl bg-surface" data-id="element-75" data-mp="2ybeda262b4wr">
            <img src={AUTHOR_IMAGE} alt="Dr. Valeria Montes in her orthodontic clinic" className="h-[460px] w-full object-cover object-top sm:h-[560px]" data-id="element-76" data-mp="33963mrr26iyu" />
          </div>
          <div className="mt-4 text-center lg:text-left" data-id="element-77" data-mp="3d7vmamqs47g5">
            <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-78" data-mp="3d599a7l4czqj">Meet the Author</p>
            <p className="mt-1 text-2xl font-black text-ink" data-id="element-79" data-mp="shd3thmeyc9j">Dr. Valeria Montes</p>
            <p className="text-sm text-ink-muted" data-id="element-80" data-mp="sj7mepa7psag">Author of SELF-LIGATING ORTHODONTICS BLUEPRINT™</p>
          </div>
        </div>

        <div data-id="element-81" data-mp="1z8ifcvtfzfbl">
          <h2 className="text-[28px] font-black leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-82" data-mp="1z8s28aj6x6d2">
            A Message From Dr. Valeria Montes
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink-muted sm:text-lg" data-id="element-83" data-mp="1q8c4zit1ivgn">
            <p data-id="element-84" data-mp="1qaomxvyst5tp">
              When you're learning about self-ligating orthodontics, it's easy to become overwhelmed by the amount of
              information available.
            </p>
            <p data-id="element-85" data-mp="1ggfu175uvav0">
              There are different bracket mechanisms, archwire materials, biomechanical concepts, treatment philosophies, and
              clinical considerations. And understanding one topic doesn't automatically explain how it connects with the
              others.
            </p>
            <p data-id="element-86" data-mp="12kuavgmazlai">
              That's why I believe organized educational resources can be so valuable.{" "}
              <strong className="text-ink" data-id="element-87" data-mp="xm0vtjrdbm88">SELF-LIGATING ORTHODONTICS BLUEPRINT™</strong> brings these subjects together in a
              structured collection.
            </p>
            <p className="rounded-2xl bg-brand-soft p-5 font-semibold text-ink" data-id="element-88" data-mp="swgllqm9dkmv">
              The objective is simple: help you study the principles behind self-ligating orthodontics through a clearer, more
              connected framework.
            </p>
            <p data-id="element-89" data-mp="16ma9a5m11yv0">
              I want you to be able to move from fundamental concepts to treatment-planning considerations without constantly
              jumping between disconnected topics. The six volumes are organized around the questions that matter throughout
              the educational planning process:
            </p>
          </div>

          <ol className="mt-5 space-y-2.5" data-id="element-90" data-mp="11tqtr33s4tnk">
            {authorQuestions.map((q, i) => <li key={q} className="flex items-center gap-3 text-[15px] font-semibold text-ink sm:text-base" data-id="element-91" data-mp="1pk39h059nuop" data-mpi={i}>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-navy-900 text-xs font-black text-gold" data-id="element-92" data-mp="1udz7g2lj5hjv">
                  {["I", "II", "III", "IV", "V", "VI"][i]}
                </span>
                {q}
              </li>)}
          </ol>

          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink-muted sm:text-lg" data-id="element-93" data-mp="3orjuypkwbr2i">
            <p data-id="element-94" data-mp="3ju1qpchtq00u">
              The goal is not to offer a shortcut around professional education. It's to provide a structured reference that
              supports deeper understanding.
            </p>
            <p className="text-xl font-black leading-snug text-ink" data-id="element-95" data-mp="2r6fgvmi05z5j">
              Because in orthodontics, knowing the appliance is only one part of understanding the treatment.
            </p>
            <p className="font-bold italic text-brand" data-id="element-96" data-mp="311h42cspwr5h">— Dr. Valeria Montes</p>
          </div>

          <SectionCta label="Get the System by Dr. Valeria Montes" data-id="element-97" data-mp="kcbl700uq2xc" />
        </div>
      </div>
    </section>;
}